<template>
    <div class="container-fluid row">
        <!-- Formulaire -->
        <div id="formulaire" class="col-md-8 mb-5">
            <p><i>Merci de répondre aux différentes questions et options.</i></p>
            <!-- Garantie de base -->
            <h2>Souscrire une garantie de base</h2>
            <p class="intitule">Quelle est votre activité ?</p>
            <!-- Classe -->
            <div class="form-check">
                <label class="form-check-label" for="classe1">
                    <input class="" id="classe1" type="radio" name="classe" value="1" v-model.number="classe" @change="calculerContratBase()">
                    <strong>CLASSE 1</strong>Toute activité socioculturelle ou sportive non énoncée en classe 2.
                </label>
            </div>
            <div class="form-check">
                <label class="form-check-label" for="classe2">
                    <input class="" id="classe2" type="radio" name="classe" value="2" v-model.number="classe" @change="calculerContratBase()">
                    <strong>CLASSE 2</strong>Arts martiaux, Boxe, Football, Lutte, Montagnisme (ski, raquette, randonnée, VTT, traineaux à chiens),
                    Nautisme, Patinage à roulettes, Roller, Rugby, Skateboard,Sports cyclistes (cyclotourisme, Cyclisme, VTT), Sports de glace.
                </label>
            </div>
            <div class="form-check mb-4">
                <label class="form-check-label" for="classe3">
                    <input class="" id="classe3" type="radio" name="classe" value="3" v-model.number="classe" @change="calculerContratBase()">
                    <strong>CLASSE 3</strong>Maison d'Assistante Maternelle avec RC professionnelle
                </label>
            </div>
            <!-- Nombre de membres / enfants -->
            <div class="row" v-if="classe !== null">
                <label for="nbMembres" class="col-sm-12 col-md-6 col-form-label">
                    Nombre {{ classe === 3 ? "d'enfants" : 'de membres'}} à couvrir
                    <div class="form-text text-danger">
                        Par tranche de {{classe === 3 ? 1 : 25}}, minimum {{minimums[classe]}}.
                    </div>
                </label>
                <div class="col-sm-12 col-md-4">
                    <NumberInputSpinner :min="minimums[classe]" :max="maximums[classe]" :step="classe === 3 ? 1 : 25" :integerOnly="true" :mouseDownSpeed="500" :value="tranches_classe" v-model.number="tranches_classe" :disabled="classe === null"  @input="calculerContratBase()" required />
                    <div class="form-text">
                        Par tranche de {{classe === 3 ? 1 : 25}}, minimum {{minimums[classe]}}.
                    </div>
                </div>
            </div>


            <h2 class="mt-5">Souhaitez-vous souscrire à des options complémentaires ?</h2>
            <p><i>Cliquez sur la ou les options souhaitées et renseignez les champs correspondants.</i></p>
            <div class="accordion" id="accordionOptions" v-if="classe !== null && tranches_classe !== null">
                <!-- Option A -->
                <div class="card">
                    <h3 class="card-header" id="headOptionA" v-bind:class="{'accordion-success': +option_a > 0 }">
                        <button class="card-button btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOptionA" aria-expanded="true" aria-controls="collapseOptionA">
                            Assurance des locaux permanents
                        </button>
                    </h3>
                    <div id="collapseOptionA" class="accordion-collapse show" aria-labelledby="headOptionA">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-form-label">
                                    Surface développée (en m<sup>2</sup>)
                                    <div class="form-text text-danger">Par tranche entière de {{tarifs['OptionA']['tranche']}}m<sup>2</sup></div>
                                </div>
                                <div class="col-sm-12 col-md-4">
                                    <NumberInputSpinner :min="0" :max="50000" :step="100" :integerOnly="true" :mouseDownSpeed="500"  v-model="option_a" @input="calculerOption($event, 'option_a')" />
                                    <div class="form-text">{{tarifs['OptionA']['tarif']}} € / tranche entière à assurer.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Option B -->
                <div class="card">
                    <h3 class="card-header" id="headOptionB" v-bind:class="{'accordion-success': +option_b > 0 }">
                        <button class="card-button btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOptionB" aria-expanded="true" aria-controls="collapseOptionB">
                            Assurance des biens mobiliers
                        </button>
                    </h3>
                    <div id="collapseOptionB" class="accordion-collapse" aria-labelledby="headOptionB">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-form-label">
                                    Montant du mobilier à souscrire (en €uros)
                                    <div class="form-text text-danger">Par tranche entière de {{tarifs['OptionB']['tranche']}} €</div>
                                </div>
                                <div class="col-sm-12 col-md-4">
                                    <NumberInputSpinner :min="0" :max="120000" :step="15000" :integerOnly="false" :mouseDownSpeed="500" v-model="option_b" @input="calculerOption($event, 'option_b')" />
                                    <div class="form-text">
                                        {{tarifs['OptionB']['tarif']}} € / tranche entière à assurer.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Option RI -->
                <div class="card">
                    <h3 class="card-header" id="headOptionRI" v-bind:class="{'accordion-success': +option_RI > 0 }">
                        <button class="card-button btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOptionRI" aria-expanded="true" aria-controls="collapseOptionRI">
                            Tous risques informatiques
                        </button>
                    </h3>
                    <div id="collapseOptionRI" class="accordion-collapse" aria-labelledby="headOptionRI">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-form-label">
                                    Valeur du matériel à neuf (en €uros)
                                    <div class="form-text text-danger">Par tranche entière de {{tarifs['OptionRI']['tranche']}} €</div>
                                </div>
                                <div class="col-sm-12 col-md-4">
                                    <NumberInputSpinner :min="0" :max="60000" :step="15000" :integerOnly="false" :mouseDownSpeed="500" v-model="option_RI" @input="calculerOption($event, 'OptionRI')" />
                                    <div class="form-text">{{tarifs['OptionRI']['tarif']}} € / tranche entière à assurer.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Option Instruments -->
                <div class="card">
                    <h3 class="card-header" id="headOptionInstruments" v-bind:class="{'accordion-success': +option_instruments_propre > 0 ||+option_instruments_asso > 0 }">
                        <button class="card-button btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOptionInstruments" aria-expanded="true" aria-controls="collapseOptionInstruments">
                            Tous risques Instruments de musique
                        </button>
                    </h3>
                    <div id="collapseOptionInstruments" class="accordion-collapse" aria-labelledby="headOptionInstruments">
                        <div class="card-body">
                            <p class="intitule">Valeur des instruments</p>
                            <div class="row">
                                <div class="offset-1 col-5 col-form-label">appartenant à l'association</div>
                                <div class="col-sm-12 col-md-4">
                                    <div class="input-group">
                                        <input type="text" class="form-control text-end" v-model.number="option_instruments_asso" @input="calculerOption($event, 'ExtensionInstruments')" />
                                        <span class="input-group-text">€</span>
                                    </div>
                                    <div class="form-text">{{tarifs['ExtensionInstruments']['pourcentage']}} % de la valeur.</div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="offset-1 col-5 col-form-label">
                                    vous appartenant en bien propre
                                    <div class="form-text text-danger">Maximum cumulé 100 000 €</div>
                                </div>
                                <div class="col-sm-12 col-md-4">
                                    <div class="input-group">
                                        <input type="text" class="form-control text-end" v-model.number="option_instruments_propre" @input="calculerOption($event, 'ExtensionInstrumentsBiensPropres')" />
                                        <span class="input-group-text">€</span>
                                    </div>
                                    <div class="form-text">{{tarifs['ExtensionInstrumentsBiensPropres']['pourcentage']}} % de la valeur.</div>

                                    <div class="form-text">
                                        Maximum cumulé : 100 000€.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Option vidéo / photo / son, lumières, groupe électrogène -->
                <div class="card">
                    <h3 class="card-header" id="headOptionSonLumiere" v-bind:class="{'accordion-success': +option_video > 0 }">
                        <button class="card-button btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOptionSonLumiere" aria-expanded="true" aria-controls="collapseOptionSonLumiere">
                            Tous risques Son & Lumière
                        </button>
                    </h3>
                    <div id="collapseOptionSonLumiere" class="accordion-collapse" aria-labelledby="headOptionSonLumiere">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-form-label">
                                    Valeur du matériel à neuf (en €uros)
                                    <div class="form-text text-danger">Par tranche entière de {{tarifs['ExtensionPhotoVideoSonLumiere']['tranche']}} €</div>
                                </div>
                                <div class="col-sm-12 col-md-4">
                                    <NumberInputSpinner :min="0" :max="100000" :step="10000" :integerOnly="false" :mouseDownSpeed="500" v-model="option_video" @input="calculerOption($event, 'ExtensionPhotoVideoSonLumiere')" />
                                    <div class="form-text">
                                        {{tarifs['ExtensionPhotoVideoSonLumiere']['tarif']}} € / tranche entière à assurer.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Accidents corporels -->
                <div class="card">
                    <h3 class="card-header" id="headOptionAccidentsCorporels" v-bind:class="{'accordion-success': +option_dommages_corporels > 0 }">
                        <button class="card-button btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOptionAccidentsCorporels" aria-expanded="true" aria-controls="collapseOptionAccidentsCorporels">
                            Accidents corporels des adhérents / pratiquants
                        </button>
                    </h3>
                    <div id="collapseOptionAccidentsCorporels" class="accordion-collapse" aria-labelledby="headOptionAccidentsCorporels">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-form-label">
                                    Nombre de personnes
                                    <div class="form-text text-danger">{{tarifs['OptionDommagesCorporels']['tarif']}} € / personne</div>
                                </div>
                                <div class="col-sm-12 col-md-4">
                                    <NumberInputSpinner :min="0" :max="300" :step="1" :integerOnly="false" :mouseDownSpeed="500" v-model="option_dommages_corporels" @input="calculerOption($event, 'OptionDommagesCorporels')" />
                                    <div class="form-text">
                                        {{tarifs['OptionDommagesCorporels']['tarif']}} € / bénévole
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Auto-Mission -->
                <div class="card">
                    <h3 class="card-header" id="headOptionAutoMission" v-bind:class="{'accordion-success': +option_am > 0 }">
                        <button class="card-button btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOptionAutoMission" aria-expanded="true" aria-controls="collapseOptionAutoMission">
                            Auto-Mission
                        </button>
                    </h3>
                    <div id="collapseOptionAutoMission" class="accordion-collapse" aria-labelledby="headOptionAutoMission">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-form-label">
                                    Nombre de véhicules à couvrir
                                    <div class="form-text text-danger">{{tarifs['OptionAM']['tarif']}} € / véhicule</div>
                                </div>
                                <div class="col-sm-12 col-md-4">
                                    <NumberInputSpinner :min="0" :max="300" :step="1" :integerOnly="false" :mouseDownSpeed="500" v-model="option_am" @input="calculerOption($event, 'OptionAM')" />
                                    <div class="form-text">
                                        {{tarifs['OptionAM']['tarif']}} € / véhicule
                                    </div>
                                </div>
                            </div>
                            <p><i>En cas souscription à cette option, vous serrez contacté par la personne responsable de votre dossier afin de procéder à des vérifications supplémentaires.</i></p>
                        </div>
                    </div>
                </div>
                <!-- Annulation de manifestations -->
                <div class="card">
                    <h3 class="card-header" id="headOptionAnnulationManifestation" v-bind:class="{'accordion-success': +option_manifestation_budget > 0 }">
                        <button class="card-button btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOptionAnnulationManifestation" aria-expanded="true" aria-controls="collapseOptionAnnulationManifestation">
                            Annulation de manifestation
                        </button>
                    </h3>
                    <div id="collapseOptionAnnulationManifestation" class="accordion-collapse" aria-labelledby="headOptionAnnulationManifestation">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-form-label">Lieu d'organisation : nature du local</div>
                                <div class="col-5">
                                    <div class="form-check form-check-inline">
                                        <label for="type_local_dur" class="form-check-label">
                                            <input type="radio" class="" id="type_local_dur" name="type_local" value="2" v-model.number="option_manifestation_typelocal" @input="calculerOption($event, 'AnnulationManifestationsLocauxDurs', 'AnnulationManifestation', 'manifestationBudget')">
                                            <span>En dur</span>
                                        </label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <label for="type_local_pleinair" class="form-check-label">
                                            <input type="radio" class="" id="type_local_pleinair" name="type_local" value="1" v-model.number="option_manifestation_typelocal" @input="calculerOption($event, 'AnnulationManifestationsPleinAir', 'AnnulationManifestation', 'manifestationBudget')">
                                            <span>En plein air</span>
                                        </label>
                                    </div>
                                    <a class="link link-danger" @click.prevent="uncheckAll('option_manifestation_typelocal', ['option_manifestation_budget'])">Effacer</a>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-form-label">Montant des dépenses de la manifestation</div>
                                <div class="col-sm-12 col-md-4">
                                    <div class="input-group">
                                        <input ref="manifestationBudget" :disabled="option_manifestation_typelocal === null" type="text" class="form-control text-end" v-model.number="option_manifestation_budget" @input="calculerOption($event, option_manifestation_typelocal === 1 ? 'AnnulationManifestationsPleinAir' : 'AnnulationManifestationsLocauxDurs', 'AnnulationManifestation')">
                                        <span class="input-group-text">€</span>
                                    </div>
                                </div>
                            </div>
                            <p>{{tarifs['AnnulationManifestationsLocauxDurs']['pourcentage']}} % pour les locaux en dur, {{tarifs['AnnulationManifestationsPleinAir']['pourcentage']}} % en plein air</p>
                        </div>
                    </div>
                </div>
                <!-- Chapiteaux -->
                <div class="card">
                    <h3 class="card-header" id="headOptionChapiteaux">
                        <button class="card-button btn btn-link btn-block text-left" v-bind:class="{'accordion-success': +option_chapiteaux > 0 }" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOptionChapiteaux" aria-expanded="true" aria-controls="collapseOptionChapiteaux">
                            Chapiteaux mis à disposition
                        </button>
                    </h3>
                    <div id="collapseOptionChapiteaux" class="accordion-collapse" aria-labelledby="headOptionChapiteaux">
                        <div class="card-body">
                            <div class="row">
                                <p><strong class="text-danger">ATTENTION : Nouveau mode de calcul</strong></p>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-form-label">
                                    Valeur de la structure
                                    <div class="form-text text-danger">Par tranche entière de {{tarifs['OptionChapiteaux']['tranche']}} €</div>
                                </div>
                                <div class="col-sm-12 col-md-4">
                                    <NumberInputSpinner :max="50000" :step="10000" :integerOnly="false" :mouseDownSpeed="500" ref="option_chapiteaux" v-model="option_chapiteaux" @input="calculerOption($event, 'OptionChapiteaux')" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Chars -->
                <div class="card">
                    <h3 class="card-header" id="headOptionChars" v-bind:class="{'accordion-success': chars_code.length > 0 }">
                        <button class="card-button btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOptionChars" aria-expanded="true" aria-controls="collapseOptionChars">
                            Circulation des chars
                        </button>
                    </h3>
                    <div id="collapseOptionChars" class="accordion-collapse" aria-labelledby="headOptionChars">
                        <div class="card-body">
                            <p class="intitule">Qui organise les manifestations à couvrir ?</p>
                            <div class="row">
                                <div class="offset-1 col-5 align-top">
                                    <div class="form-check form-check-inline">
                                        <input id="chars_organisateur_am" type="checkbox" class="form-check-input" name="chars_organisateur" value="AM" v-model="chars_organisateur">
                                        <label for="chars_organisateur_am" class="form-check-label">Mon association</label>
                                        <div v-if="chars_organisateur.includes('AM')">
                                            <div class="form-check">
                                                <input id="am_chars_code_1d20c" type="checkbox" class="chars_am form-check-input" name="code_chars" value="1D20C" v-model="chars_code" @click="uncheckOtherCheckboxes($event, 'chars_am')">
                                                <label for="am_chars_code_1d20c" class="form-check-label">1 défilé max 20 chars</label>
                                            </div>
                                            <div class="form-check">
                                                <input id="am_chars_code_1d30c" type="checkbox" class="chars_am form-check-input" name="code_chars" value="1D30C" v-model="chars_code" @click="uncheckOtherCheckboxes($event, 'chars_am')">
                                                <label for="am_chars_code_1d30c" class="form-check-label">1 défilé max 30 chars</label>
                                            </div>
                                            <div class="form-check">
                                                <input id="am_chars_code_3d20c" type="checkbox" class="chars_am form-check-input" name="code_chars" value="3D20C" v-model="chars_code" @click="uncheckOtherCheckboxes($event, 'chars_am')">
                                                <label for="am_chars_code_3d20c" class="form-check-label">3 défilés max 20 chars</label>
                                            </div>
                                            <div class="form-check">
                                                <input id="am_chars_code_3d30c" type="checkbox" class="chars_am form-check-input" name="code_chars" value="3D30C" v-model="chars_code" @click="uncheckOtherCheckboxes($event, 'chars_am')">
                                                <label for="am_chars_code_3d30c" class="form-check-label">3 défilés max 30 chars</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-5 align-top">
                                    <div class="form-check form-check-inline">
                                        <input id="chars_organisateur_aa" type="checkbox" class="form-check-input" name="chars_organisateur" value="AA" v-model="chars_organisateur">
                                        <label for="chars_organisateur_aa" class="form-check-label">Une autre association</label>
                                        <div v-if="chars_organisateur.includes('AA')">
                                            <div class="form-check">
                                                <input id="aa_chars_code_2d20c" type="checkbox" class="chars_aa form-check-input" name="code_chars" value="2D20C" v-model="chars_code" @click="uncheckOtherCheckboxes($event, 'chars_aa')">
                                                <label for="aa_chars_code_2d20c" class="form-check-label">2 défilés max 20 chars</label>
                                            </div>
                                            <div class="form-check">
                                                <input id="aa_chars_code_5d20c" type="checkbox" class="chars_aa form-check-input" name="code_chars" value="5D20C" v-model="chars_code" @click="uncheckOtherCheckboxes($event, 'chars_aa')">
                                                <label for="aa_chars_code_5d20c" class="form-check-label">5 défilés max 20 chars</label>
                                            </div>
                                            <div class="form-check">
                                                <input id="aa_chars_code_15d20c" type="checkbox" class="chars_aa form-check-input" name="code_chars" value="15D20C" v-model="chars_code" @click="uncheckOtherCheckboxes($event, 'chars_aa')">
                                                <label for="aa_chars_code_15d20c" class="form-check-label">15 défilés max 20 chars</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Biens exposés -->
                <div class="card">
                    <h3 class="card-header" id="headOptionBiensExposes" v-bind:class="{'accordion-success': +option_biens_exposes > 0 }">
                        <button class="card-button btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOptionBiensExposes" aria-expanded="true" aria-controls="collapseOptionBiensExposes">
                            Biens exposés
                        </button>
                    </h3>
                    <div id="collapseOptionBiensExposes" class="accordion-collapse" aria-labelledby="headOptionBiensExposes">
                        <div class="card-body">
                            <p class="intitule">Maximum 10 000€ de biens à couvrir par exposition</p>
                            <div class="form-check form-check-inline">
                                <label for="biens_exposes_2" class="form-check-label">
                                    <input type="radio" class="" name="biens_exposes" id="biens_exposes_2" value="2" v-model="option_biens_exposes">
                                    <span>2 expositions / an</span>
                                </label>
                            </div>
                            <div class="form-check form-check-inline">
                                <label for="biens_exposes_5" class="form-check-label">
                                    <input type="radio" class="" name="biens_exposes" id="biens_exposes_5" value="5" v-model="option_biens_exposes">
                                    <span>5 expositions / an</span>
                                </label>
                            </div>
                            <a class="link link-danger" @click.prevent="uncheckAll('option_biens_exposes', [], 'OptionBiensExposes')">Effacer</a>
                        </div>
                    </div>
                </div>
                <!-- Interruption de séjour -->
                <div class="card">
                    <h3 class="card-header" id="headOptionInterruptionSejour" v-bind:class="{'accordion-success': +option_sejour > 0 }">
                        <button class="card-button btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOptionInterruptionSejour" aria-expanded="true" aria-controls="collapseOptionInterruptionSejour">
                            Annulation / interruption de séjour - perte de bagage
                        </button>
                    </h3>
                    <div id="collapseOptionInterruptionSejour" class="accordion-collapse" aria-labelledby="headOptionInterruptionSejour">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-form-label">
                                    Coût annuel TTC de l'ensemble des voyages
                                    <div class="form-text text-danger">{{tarifs['ExtensionVoyages']['pourcentage']}} % du coût annuel total</div>
                                </div>
                                <div class="col-sm-12 col-md-4">
                                    <div class="input-group">
                                        <input type="text" class="form-control text-end" v-model.number="option_sejour" @input="calculerOption($event, 'ExtensionVoyages')" />
                                        <span class="input-group-text">€</span>
                                    </div>
                                    <div class="form-text">
                                        {{tarifs['ExtensionVoyages']['pourcentage']}} % du coût annuel des voyages
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Masques & Costumes -->
                <div class="card">
                    <h3 class="card-header" id="headOptionMasquesCostumes">
                        <button class="card-button btn btn-link btn-block text-left" v-bind:class="{'accordion-success': +option_masques_costumes > 0 }" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOptionMasquesCostumes" aria-expanded="true" aria-controls="collapseOptionMasquesCostumes">
                            Masques et Costumes
                        </button>
                    </h3>
                    <div id="collapseOptionMasquesCostumes" class="accordion-collapse" aria-labelledby="headOptionMasquesCostumes">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-form-label">
                                    Valeur déclarée
                                    <div class="form-text text-danger">
                                        Par tranche entière de {{tarifs['OptionMasquesCostumes']['tranche']}} €,<br>
                                        maximum 50 000€
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-4">
                                    <NumberInputSpinner :max="50000" :step="10000" :integerOnly="false" :mouseDownSpeed="500" ref="option_masques_costumes" v-model="option_masques_costumes" @input="calculerOption($event, 'OptionMasquesCostumes')" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Protection Juridique -->
                <div class="card">
                    <h3 class="card-header" id="headOptionProtectionJuridique" v-bind:class="{'accordion-success': +tranches_pj > 0 }">
                        <button class="card-button btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOptionProtectionJuridique" aria-expanded="true" aria-controls="collapseOptionProtectionJuridique">
                            Protection Juridique
                        </button>
                    </h3>
                    <div id="collapseOptionProtectionJuridique" class="accordion-collapse" aria-labelledby="headOptionProtectionJuridique">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-form-label">Votre association a-t-elle des salariés (<abbr title="Guichet Unique du Spectacle Occasionnel">GUSO</abbr> et <abbr title="Chèque Emploi Association">CEA</abbr> compris) ?</div>
                                <div class="col-sm-12 col-md-4">
                                    <div class="form-check form-check-inline">
                                        <label for="type_pj_non" class="form-check-label">
                                            <input id="type_pj_non" type="radio" class="" name="type_pj" value="1" v-model.number="type_pj" @input="calculerOption(tranches_pj, 'ProtectionJuridiqueSansSalaries', 'ProtectionJuridique')">
                                            <span>Non</span>
                                        </label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <label for="type_pj_oui" class="form-check-label">
                                            <input id="type_pj_oui" type="radio" class="" name="type_pj" value="2" v-model.number="type_pj" @input="calculerOption(tranches_pj, 'ProtectionJuridiqueAvecSalaries', 'ProtectionJuridique')">
                                            <span>Oui</span>
                                        </label>
                                    </div>
                                    <a class="link link-danger" @click.prevent="uncheckAll('type_pj', ['tranches_pj', 'salaries_pj'], ['ProtectionJuridique', 'ProtectionJuridiqueParSalarie'])">Effacer</a>
                                </div>
                            </div>
                            <div class="row mt-2" v-if="type_pj === 2">
                                <div class="col-sm-12 col-md-6 col-form-label">
                                    Nombre de salariés
                                    <div class="form-text text-danger">{{tarifs['ProtectionJuridiqueParSalarie']['tarif']}} € /salarié</div>
                                </div>
                                <div class="col-sm-12 col-md-4">
                                    <NumberInputSpinner :min="0" :step="1" :integerOnly="false" :mouseDownSpeed="500" :value="salaries_pj" v-model.number="salaries_pj" @input="calculerOption($event, 'ProtectionJuridiqueParSalarie')" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <p v-else>Les options complémentaires sont disponibles après avoir sélectionnée une garantie de base.</p>
        </div>

        <!-- Explication des options -->
        <div class="container-fluid col-md-4 overflow-auto h-100">
            <div id="cartouches">
                <!-- Récaptitulatif du contrat -->
                <div id="recapitulatif" class="alert alert-success mb-5">
                    <h4 class="text-center mb-4">Récapitulatif<br>de votre simulation</h4>
                    <dl class="row fs-6">
                        <template v-for="(item, index) in contratOrdonne">
                            <dd class="col-8" :key="index + '-dd'" v-if="item.tranches > 0">{{item.libelle}}</dd>
                            <dt class="col-4 text-right" :key="index + '-dt'" v-if="item.tranches > 0">{{item.tarif.toFixed(2)}} €</dt>
                        </template>
                    </dl>
                    <hr>
                    <div class="row">
                        <div class="col-7"><strong>TOTAL ANNUEL TTC</strong></div>
                        <div class="col-5 text-right">
                            <strong>{{montantContrat.toFixed(2)}} €</strong>
                        </div>
                    </div>
                    <div class="row" v-show="+montantContrat > 0">
                        <button class="btn btn-lg bg-ffba btn-block" @click="imprimer">Imprimer ma simulation</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NumberInputSpinner from '@/components/NumberInputSpinner.vue'
import { mapGetters, mapActions } from 'vuex'
import jsConvert from 'js-convert-case'
import _ from 'underscore'


export default {
    name: 'Formulaire',
    title: 'Souscrivez en ligne',

    components: {
        NumberInputSpinner,
    },

    data() {
        return {
            minimums: {
                1: 25,
                2: 75,
                3: 1,
                instruments: 22,
            },

            maximums: {
                1: 300,
                2: 300,
                3: 20
            },

            classe: null,
            tranches_classe: null,
            option_a: null,
            option_b: null,
            option_RI: null,
            option_instruments_asso: null,
            option_instruments_propre: null,
            option_video: null,
            option_am: null,
            option_chapiteaux: null,
            option_manifestation_budget: null,
            option_manifestation_typelocal: null,
            option_masques_costumes: null,
            option_biens_exposes: null,
            option_sejour: null,
            chapiteaux_duree_max: null,
            chapiteaux_mois_supplementaires: null,
            chapiteaux_valeur: null,
            chars_organisateur: [],
            chars_code: [],
            type_pj: null,
            tranches_pj: null,
            salaries_pj: null,
            option_dommages_corporels: null,

            contrat: [],

            locaux: [
                {adresse: null, proprietaire: false},
                {adresse: null, proprietaire: false},
            ],
        }
    },

    created: function() {
        this.getTarifs()
    },

    methods: {
        ...mapActions(['getTarifs']),

        /**
         * Précise le type de local et corrige le budget dans l'option correspondante.
         */
        addTypeToAnnulationManifestation: function() {
            let souscription = _.findWhere(this.contrat, {nom: 'AnnulationManifestation'})

            if (souscription !== undefined) {
                souscription.type = this.option_manifestation_typelocal
                souscription.tranches = this.option_manifestation_budget
                this.insertIntoContrat('AnnulationManifestation', souscription)
            }
        },

        /**
         * Précise le type de protection juridique dans l'option correspondante.
         */
        addTypeToProtectionJuridique: function() {
            let souscription = _.findWhere(this.contrat, {nom: 'ProtectionJuridique'})

            if (souscription !== undefined) {
                souscription.type     = this.type_pj
                souscription.tranches = Math.max(souscription.tranches, 1)
                souscription.tarif    = parseFloat(this.tarifs[this.type_pj === 1 ? 'ProtectionJuridiqueSansSalaries' : 'ProtectionJuridiqueAvecSalaries']['tarif'])
                this.insertIntoContrat('ProtectionJuridique', souscription)
            }
        },

        calculerOptionChapiteaux: function() {
            console.log(this.chapiteaux_duree_max, this.chapiteaux_valeur)

            if (this.chapiteaux_duree_max === null || this.chapiteaux_valeur === null) {
                return
            }

            const tarif       = this.tarifs['OptionChapiteaux']
                , nb_tranches = Math.ceil(this.chapiteaux_valeur / tarif['tranche'])


            let montant = 0

            montant = nb_tranches * tarif[this.chapiteaux_duree_max]

            if (this.chapiteaux_mois_supplementaires > 0) {
                montant += this.chapiteaux_mois_supplementaires * tarif['supplement']
            }

            const souscription = {
                nom: 'Chapiteaux',
                libelle: 'Chapiteaux mis à disposition',
                tranches: this.chapiteaux_valeur,
                duree: this.chapiteaux_duree_max,
                mois_supplementaires: this.chapiteaux_mois_supplementaires,
                tarif: parseFloat(montant),
                ordre: tarif.ordre
            }

            this.insertIntoContrat('Chapiteaux', souscription)
        },

        calculerContratBase: function() {
            const classe_applicable     = `Classe${this.classe}`
                , tarifs_classe         = this.tarifs[classe_applicable]
                , membres_max           = parseInt(tarifs_classe['membres_max']) || null
                , tranche_suppl         = parseInt(tarifs_classe['tranche'])
                , supplement            = parseInt(tarifs_classe['supplement'])
                ;

            let tarif                = null
              , tranches_applicables = null
              ;

            // On borne les tranches de classe sélectionnées
            this.tranches_classe = Math.max(this.tranches_classe, this.minimums[this.classe])
            this.tranches_classe = Math.min(this.tranches_classe, this.maximums[this.classe])

            tranches_applicables = Math.ceil(this.tranches_classe / tranche_suppl)

            if (this.classe === 3) {
                tarif = this.tranches_classe * supplement;
            } else if (this.tranches_classe <= membres_max) {
                tarif = tarifs_classe[tranches_applicables * tranche_suppl]
            } else {
                tarif = parseInt(tarifs_classe[membres_max]) + (((this.tranches_classe - membres_max) / tranche_suppl) * supplement);
            }

            const souscription =  {
                nom: 'ContratBase',
                libelle: 'Garantie de base',
                tranches: this.tranches_classe / tranche_suppl,
                classe: this.classe,
                tarif: parseFloat(tarif),
                ordre: tarifs_classe.ordre
            };

            this.insertIntoContrat('ContratBase', souscription);
        },

        /**
         * Permet de calculer le montant d'une option pour insertion dans le contrat.
         *
         * @param $event Valeur à partir de laquelle calculer
         * @param option Nom de l'option dans le fichier de tarification
         * @param insertAs Label à utiliser pour insertion dans le contrat (pour regrouper certains calculs sous un même label et fait jour l'écrasement des données)
         * @param champSupp Champ supplémentaire à utiliser dans le calcul avec $event
         */
        calculerOption: function($event, option, insertAs, champSupp) {

            const option_tarif = _.has(this.tarifs, option) ? option : jsConvert.toPascalCase(option)
                , libelle      = this.tarifs[option_tarif]['libelle']
                , ordre        = this.tarifs[option_tarif]['ordre']
                ;

            let tranches     = null
              , tarif        = null
              ;

            if (_.has(this.tarifs[option_tarif], 'tranche')) {
                tranches = Math.ceil(Math.abs($event / this.tarifs[option_tarif]['tranche']))
                tarif    = tranches * this.tarifs[option_tarif]['tarif']
            }

            if  (_.has(this.tarifs[option_tarif], 'pourcentage')) {
                tranches = Math.ceil(Math.abs(typeof $event === Number ? $event : $event.target.value))
                tarif    = ((champSupp !== undefined ? this.$refs[champSupp].value : $event.target.value) * parseFloat(this.tarifs[option_tarif]['pourcentage']) / 100)

                if (['ExtensionInstruments', 'ExtensionInstrumentsBiensPropres'].includes(insertAs || option)) {
                    tarif = Math.max(this.minimums.instruments, tarif)
                }
            }

            const souscription = {
                nom: insertAs || option,
                libelle: libelle,
                tranches: tranches,
                tarif: tarif,
                ordre: ordre
            };

            this.insertIntoContrat(insertAs || option, souscription)
        },

        imprimer: function() {
            window.print();
        },

        /**
         * Insère ou écrase une souscription d'option dans le contrat en fonction de la présence ou non de cle dans celui-ci.
         *
         * @param cle   Clé permettant de retrouver une souscription par son nom
         * @param souscription Objet définissant la souscription à l'option
         */
        insertIntoContrat: function(cle, souscription) {
            const elt = _.findWhere(this.contrat, {nom: cle})
                , idx = _.indexOf(this.contrat, elt)
                ;

            if (idx === -1) {
                this.contrat.push(souscription)
            } else {
                this.contrat[idx] = souscription
            }
        },

        /**
         * Réinitialise un groupe de coches radio en vidant les options associés et l'entrée dans le contrat.
         *
         * @param option            Nom du champ radio à réinitialiser
         * @param emptyOption       Nom des champs dépendants à réinitialiser
         * @param emptyInContrat    Nom de l'objet correspondant dans le contrat
         */
        uncheckAll: function(option, emptyOption, emptyInContrat) {
            this[option] = null;

            if (emptyOption !== undefined) {
                if (typeof emptyOption === 'string') {
                    this[emptyOption] = null
                }

                if (typeof emptyOption === 'object') {
                    emptyOption.forEach(element => {
                        this[element] = null
                    }, this);
                }
            }

            if (emptyInContrat !== undefined) {
                if (typeof emptyInContrat === 'string') {
                    this.contrat = _.reject(this.contrat, {'nom': emptyInContrat});
                }

                if (typeof emptyInContrat === 'object') {
                    emptyInContrat.forEach(element => {
                        this.contrat = _.reject(this.contrat, {'nom': element});
                    }, this);
                }
            }
        },

        uncheckOtherCheckboxes: function(event, prefix) {
            const elt = _.findWhere(this.contrat, {nom: 'Chars'})
                , idx = _.indexOf(this.contrat, elt)


            if (idx !== -1) {
                _.each(document.querySelectorAll(`.${prefix}`), function(el) {
                    const subelt = _.indexOf(this.contrat[idx].code, el.value)

                    if (subelt !== -1) {
                        this.contrat[idx].code.splice(subelt, 1)
                    }
                }, this)
            }
        },
    },

    computed: {
        ...mapGetters({tarifs: 'stateTarifs', user: 'stateUser'}),

        demiTarif: {
            cache: true,
            get() {
                const aujourdhui = new Date()
                    , pivot_debut = new Date(`${aujourdhui.getFullYear()}-06-30`)
                    , pivot_fin = new Date(`${aujourdhui.getFullYear()}-12-15`)

                return aujourdhui > pivot_debut && aujourdhui < pivot_fin
            }
        },

        montantContrat: {
            cache: false,
            get() {
                let montant = _.reduce(this.contrat, (memo, item) => memo + item.tarif, 0)

                return montant
            }
        },

        contratOrdonne: {
            cache: false,
            get() {
                return _.sortBy(_.reject(this.contrat, (x) => x.show === false), (x) => parseInt(x.ordre))
            }
        }
    },

    watch: {
        chapiteaux_duree_max: function() {
            this.calculerOptionChapiteaux()
        },

        chapiteaux_mois_supplementaires: function() {
            this.calculerOptionChapiteaux()
        },

        chapiteaux_valeur: function() {
            this.calculerOptionChapiteaux()
        },

        chars_code: function(codes) {
            let tarif    = 0
              , ordre    = null
              ;

            _.each(codes, (c) => {
                if (this.tarifs['OptionCirculationCharsOrgMemeAsso'][c] === undefined) {
                    tarif += parseInt(this.tarifs['OptionCirculationCharsOrgAutreAsso'][c])
                    ordre  = this.tarifs['OptionCirculationCharsOrgAutreAsso']['ordre']
                } else {
                    tarif += parseInt(this.tarifs['OptionCirculationCharsOrgMemeAsso'][c])
                    ordre  = this.tarifs['OptionCirculationCharsOrgMemeAsso']['ordre']
                }
            }, this);

            const souscription = {
                nom: 'Chars',
                libelle: 'Circulation de chars',
                tranches: 1,
                tarif: tarif,
                ordre: ordre,
                code: this.chars_code,
                organisateur: this.chars_organisateur
            };

            this.insertIntoContrat('Chars', souscription)
        },

        chars_organisateur: function(org) {
            if (org.length === 0) {
                const chars = _.findWhere(this.contrat, {nom: 'Chars'})
                this.contrat = _.without(this.contrat, chars)
            }
        },

        locaux: {
            deep: true,
            handler() {
               let souscription = _.findWhere(this.contrat, {nom: 'option_a'})

               if (souscription !== undefined) {
                   souscription.locaux = this.locaux
               }
            }
        },

        option_biens_exposes: function(jours) {
            if (jours === null) {
                return
            }

            const elt     = _.findWhere(this.contrat, {nom: 'OptionBiensExposes'})
                , idx     = _.indexOf(this.contrat, elt)
                , tarif   = parseInt(this.tarifs['OptionBiensExposes'][jours])
                , libelle = this.tarifs['OptionBiensExposes']['libelle']
                , ordre   = this.tarifs['OptionBiensExposes']['ordre']

                , souscription = {
                    nom: 'OptionBiensExposes',
                    libelle: libelle,
                    tranches: 1,
                    tarif: tarif,
                    ordre: ordre
                };

            if (idx === -1) {
                this.contrat.push(souscription)
            } else {
                this.contrat[idx] = souscription
            }
        },

        tranches_pj: function() {
            this.addTypeToProtectionJuridique()
        },

        option_manifestation_budget: function() {
            this.addTypeToAnnulationManifestation();
        },

        option_manifestation_typelocal: function() {
            this.addTypeToAnnulationManifestation();
        },

        type_pj: function() {
            this.addTypeToProtectionJuridique()
        },
    }
}
</script>

<style scoped>
.bg-ffba {
    background-color: #237895;
    color: white !important;
}

.accordion-success {
    color: hsl(152, 69%, 19%) !important;
    background-color: #d1e7dd !important;
}

/* #cartouches {
    position: fixed;
} */

.intitule {
    font-weight: bolder;
}

.form-check-label {
    text-align: justify;
}

.form-check+.form-check {
    margin-top: 0.71rem;
 }

.link-danger {
    color: #dc3545 !important;
}
</style>
